import React from "react";
import ContactForm from "../components/site/ContactForm";

export default function Contact() {
  return (
    <>
      <section className="bg-white border-b border-hairline" data-testid="contact-hero">
        <div className="max-w-content mx-auto px-4 sm:px-6 py-12 sm:py-16">
          <h1 className="text-4xl sm:text-5xl max-w-3xl mb-5">
            Request Pricing &amp; Availability
          </h1>
          <p className="text-lg text-subink max-w-2xl">
            Tell us about your practice and the leads you're looking for. A
            member of our team will follow up with per-lead pricing and current
            availability for your practice area and geography. No contracts, no
            obligation.
          </p>
        </div>
      </section>

      <section className="bg-altbg" data-testid="contact-section">
        <div className="max-w-content mx-auto px-4 sm:px-6 py-14">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
            <div className="lg:col-span-1">
              <h2 className="text-xl mb-4">Get in touch</h2>
              <div className="space-y-4 text-[15px]">
                <div>
                  <p className="text-subink text-sm">Phone</p>
                  <a href="tel:+19842612925" className="text-navy font-semibold hover:text-gold">
                    984-261-2925
                  </a>
                </div>
                <div>
                  <p className="text-subink text-sm">Email</p>
                  <a href="mailto:admin@legalconnect360.com" className="text-navy font-semibold hover:text-gold">
                    admin@legalconnect360.com
                  </a>
                </div>
                <div>
                  <p className="text-subink text-sm">Hours</p>
                  <p className="text-ink">Mon–Fri: 9:00 AM – 6:00 PM ET</p>
                </div>
              </div>
            </div>
            <div className="lg:col-span-2">
              <ContactForm sourcePage="contact" />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
